import { TMenuRow } from "../gui/Tabs/Tabs"
import Select from "../gui/Select/Select"

export type TFoodTab = TMenuRow<string>
export const Pages : TFoodTab[] = [
    {text:"Home", id:"home"},
    {text:"Meals", id:"meals"},
    {text:"Factsheet", id:"search"},
    {text:"Settings", id:"settings"},
]
export default class FoodUtils {
    static currentPage(path:string){
        const [_,page] = path.split("/")
        const current = Pages.find(p => Select.id(p)==page)
        return current || Pages[0]
    }
    static getTitle(path:string){
        return Select.text(this.currentPage(path))
    }
    static getPage(path:string){
        return Select.id(this.currentPage(path))
    }
    static get pages(){return Pages}
}